import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import NotificationIcon from "../../Assets/Images/notification.png";
import { useAuth } from "../../hooks/useAuth";
import DropdownMenu from "./DropdownMenu";

const Notification = () => {
  const [notifCount, setnotifCount] = useState([]);

  const { handleGetNotification } = useAuth();

  useEffect(() => {
    handleGetNotification().then((res) => {
      setnotifCount(res?.data?.custom_order_notification);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <span className="notification_dropdown">
      <Dropdown>
        <Dropdown.Toggle variant="" id="dropdown-basic">
          <span className={`notification`}>
            <img alt="img" src={NotificationIcon} />
            <span className={!notifCount?.length ? "bg-light" : "bg-danger"}>
              {notifCount?.length}
            </span>
          </span>
        </Dropdown.Toggle>

        <DropdownMenu />
      </Dropdown>
    </span>
  );
};

export default Notification;
